// Pure helpers for gating the Cluster swimlane behind comparisonsEnabled().
//
// The "clusters" activity-surface lens IS the swimlane. With comparisons off it
// is dropped from the lens tabs, and any stale "clusters" selection (a ?lens=
// deep link or a pinned-home lens) is coerced back to the default so the hidden,
// heavy swimlane plotConfig never gets built. Callers pass the resolved flag in
// (comparisonsEnabled()) so these stay pure and unit-testable.

const SWIMLANE_LENS = "clusters";
const DEFAULT_LENS = "endpoints";

// Drop the swimlane option from a [value, label][] lens list when off.
export function filterComparisonLensOptions(options, comparisons) {
    return comparisons ? options : options.filter(([value]) => value !== SWIMLANE_LENS);
}

// Coerce a stale "clusters" lens value back to the default when off; pass
// everything else (including kernel: lenses) through untouched.
export function coerceComparisonLens(lens, comparisons) {
    return (!comparisons && lens === SWIMLANE_LENS) ? DEFAULT_LENS : lens;
}
